import React, { useEffect } from "react"
import { Modal, Button } from 'components/common';
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { createCompetitor, updateCompetitor } from "redux/crm/competiorSlice";
import PropTypes from 'prop-types';
import { toast } from "react-toastify";

import { INPUT_CLS as INPUT_CLASSES } from 'helpers/formStyles';
const CompetitorForm = ({ showModal, setshowModal, title, competitor }) => {
  const { register, handleSubmit, formState: { errors }, setValue, reset } = useForm()

  const dispatch = useDispatch();

  useEffect(() => {
    if (title === "New Competior") {
      reset()
    }
  }, [title, reset])


  useEffect(() => {
    if (competitor) {
      Object.entries(competitor).forEach(([key, value]) => {
        setValue(key, value)
      })
    }
  }, [setValue, competitor])

  const onSubmit = async (data) => {
    try {
      let competitorId = ""

      if (competitor) {
        competitorId = competitor.id
        dispatch(updateCompetitor({ competitorId, data }))
      }
      else {
        const response = await dispatch(createCompetitor(data))
        competitorId = response.payload.id
      }

      if (competitorId) {
        closeModal()
      }
    }
    catch (error) {
      toast.error(error.message)

      return;
    }
  }

  const closeModal = () => {
    setshowModal(false)
  }

  const handleCancel = () => {
    closeModal()
  }

  const fieldRow = (label, children) => (
    <div className="tw-grid tw-grid-cols-12 tw-gap-3 tw-mb-2 tw-items-center">
      <div className="tw-col-span-12 sm:tw-col-span-3 tw-text-sm tw-font-medium tw-text-slate-700 lg:tw-text-right">
        {label}
      </div>
      <div className="tw-col-span-12 sm:tw-col-span-9 md:tw-col-span-7">
        {children}
      </div>
    </div>
  );

  const fieldError = (error) => error && (
    <span className="tw-text-red-600 tw-text-xs tw-mt-1 tw-block">{error.message}</span>
  );

  return (
    <Modal
      show={showModal}
      onHide={() => setshowModal(false)}
      title={title}
      backdropClick={false}
      footer={(
        <>
          <Button size="sm" type="submit" variant="primary" form="competitor-form">Save</Button>
          <Button size="sm" variant="danger" onClick={handleCancel}>Cancel</Button>
        </>
      )}
    >
      <form id="competitor-form" onSubmit={handleSubmit(onSubmit)}>
        {fieldRow('Name*', (
          <>
            <input
              type="text"
              placeholder="Competitor name"
              className={INPUT_CLASSES}
              {...register("name", {
                required: "Name must be required."
              })}
            />
            {fieldError(errors.name)}
          </>
        ))}

        {fieldRow('Code*', (
          <>
            <input
              type="text"
              placeholder="Competitor code"
              className={INPUT_CLASSES}
              {...register("code", {
                required: "Ccode must be required."
              })}
            />
            {fieldError(errors.code)}
          </>
        ))}
      </form>
    </Modal>
  )
};

CompetitorForm.propTypes = {
  showModal: PropTypes.bool.isRequired,
  setshowModal: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  competitor: PropTypes.object.isRequired
}

export default CompetitorForm;
